<template>
  <div class="overflow-auto bg-n-surface-1 w-full">
    <div class="w-full mx-auto pb-12 px-4">
      <router-view />
    </div>
  </div>
</template>
